import { get } from "lodash";

const buildEditorBlocks = ({
  emailContent,
  mailTranslations,
  project,
  phoneNumber,
  email,
  address,
  user,
}) => {
  return {
    blocks: [
      {
        type: "paragraph",
        data: {
          text: `Bonjour ${get(project, "contact.user.firstname")} ${get(project, "contact.user.lastname")},`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `Suite à notre conversation téléphonique, j'ai le plaisir de vous adresser votre devis personnalisé pour les solutions que nous avons évoquées ensemble.`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `Vous trouverez en pièce jointe le devis détaillé comprenant :`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `- La formule de téléconsultation solo`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `Ce devis est valable 30 jours à compter de ce jour.`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `En attendant votre décision finale, vous êtes déjà inscrit gratuitement à LaFourGale pour bénéficier gratuitement, grâce à votre Pass-conso, 1 fois par mois de 5 à 20% de réductions sur vos courses, votre énergie, vos télécoms, vos vêtements et tout le choix que vous avez dans plus de 3.000 Marques et Enseignes de Centre Commerciaux et sites e-Commerce`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `Je reste à votre entière disposition pour toute question ou complément d'information.`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `Dans l'attente de votre retour, je vous prie d'agréer, ${get(project, "contact.user.firstname")}, l'expression de mes salutations distinguées.`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `Cordialement,`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `${get(user, "firstname")} ${get(user, "lastname")}`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `Conseiller La Fourgale`,
        },
      },
    ].filter((_) => get(_, "data.text") !== undefined),
  };
};

export default buildEditorBlocks;
